import * as t from 'io-ts';

export const preAlertLog = t.type({
  pre_alert: t.number,
  edited_field: t.string,
  before_value: t.string,
  after_value: t.string,
  detail: t.string,
  updated_at: t.string,
  created_at: t.string,
  editor: t.string,
});

export type PreAlertLog = t.TypeOf<typeof preAlertLog>;

export const preAlertLogPages = t.type({
  count: t.number,
  previous: t.union([t.string, t.null]),
  next: t.union([t.string, t.null]),
  results: t.array(preAlertLog),
});
